module.exports = __webpack_public_path__ + "static/media/Flaticon.7dd66f99.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flaticons/Flaticon.ttf
// module id = 775
// module chunks = 0